import React from 'react'

import styles from './index.module.css'

type Variant = 'primary' | 'danger' | 'cancel'

const variantClass: Record<Variant, string> = {
  primary: styles.okButtonPrimary,
  danger: styles.okButtonDanger,
  cancel: styles.okButtonCancel,
}

type Props = {
  isOpen: boolean
  title: string
  description?: string
  variant?: Variant
  bordered?: boolean
  okDisabled?: boolean
  onOk: () => void
  onCancel: () => void
}

export const SpConfirmModal: React.FC<Props> = ({
  isOpen,
  title,
  description,
  variant = 'primary',
  bordered = false,
  okDisabled = false,
  onOk,
  onCancel,
}) => {
  if (!isOpen) return null

  return (
    <div className={styles.overlay} onClick={onCancel}>
      <div
        className={`${styles.card} ${bordered ? styles.cardBordered : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <p className={styles.title}>{title}</p>
        {description && <p className={styles.description}>{description}</p>}
        <div className={styles.buttonRow}>
          <button className={styles.cancelButton} onClick={onCancel}>
            キャンセル
          </button>
          <button
            className={`${styles.okButton} ${variantClass[variant]}`}
            onClick={onOk}
            disabled={okDisabled}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  )
}
